import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src3282395254/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
